var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-top"},[_c('div',{staticClass:"menu-login-section col-sm-6 col-md-3"},[_c('btnLogin'),_c('floatingCart')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }